import { useMembershipIds } from "hooks";

export const useFreeTrial = (): {
  freeTrialMembershipId: string;
} => {
  const { sixtyDayFreeTrialRenewsToAnnualMembershipId } = useMembershipIds();

  return {
    freeTrialMembershipId: sixtyDayFreeTrialRenewsToAnnualMembershipId
  };
};
